module.exports = __webpack_public_path__ + "static/img/14.f747221.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/14.jpg
// module id = XUuh
// module chunks = 16